/**
 * Wrap an axios call with Sentry logging in case the axios call is successful but there is a response header warning.
 * This ensures any silent errors from CIS will be visible in Sentry error logs.
 */

import noticeError from './noticeError'

export default async function withNoticeWarnings(axiosPromise) {
  const response = await axiosPromise
  const warning = response?.headers?.warning
  if (warning) {
    const error = new Error(`Network request was successful, but response contained warning header: ${warning}`)
    error.response = response
    noticeError(error)
  }
  return response
}
